module.exports = __webpack_public_path__ + "img/alentour7.e4fc7375.jpg";